<template>
  <!-- eslint-disable max-len -->
  <el-dialog title="更新服务" :visible="visible" @close="onClose" @open="onOpen" :close-on-click-modal="false" width="550px" @beforeopen="onOpen">
    <el-form :model="item" ref="itemform" label-width="80px" :rules="rules">
      <el-form-item label="版本号" prop="VerNumber">
        <el-input v-model.trim="item.VerNumber" placeholder="请输入版本号"></el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload ref="upload" :action="`/api/updateservice/upload/${value.SoftwareId}`" :headers="uploadHeader" :multiple="false" :limit="1" accept=".zip" :auto-upload="false" :on-success="handleSuccess" :on-error="handleError">
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    const validateVer = (rule, value, callback) => {
      if (value && !value.match(/^[0-9]{1,5}\.[0-9]{1,5}\.[0-9]{1,5}\.[0-9]{1,5}$/)) {
        callback(new Error('请输入正确的版本号'));
      } else {
        callback();
      }
    };
    return {
      item: _.clone(this.value),
      submitting: false,
      rules: {
        VerNumber: [
          { required: true, message: '版本号不能为空', trigger: 'blur' },
          { validator: validateVer, trigger: 'blur' },
        ],
      },
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem('jwtToken')}`,
        Accept: 'application/json',
      },
    };
  },
  methods: {
    onOpen() {
      this.item = {};
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.submitting = false;
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$refs.upload.submit();
      });
    },
    handleSuccess(response) {
      // eslint-disable-next-line radix
      this.item.SoftwareId = parseInt(this.value.SoftwareId);
      this.item.Md5 = response.Md5;
      this.item.Url = response.Url;
      this.$axios.post('updateservice', this.item).then(() => {
        this.$message({
          message: '上传成功!',
          type: 'success',
        });
        this.onClose();
        this.$emit('form:saved');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
        this.submitting = false;
      }).finally(() => {
        this.submitting = false;
      });
    },
    handleError(err) {
      this.$message.error(err);
    },
  },
};
</script>
